// Lightweight place-name search using OpenStreetMap Nominatim.
// Runs entirely from the browser; no backend needed.

export interface GeocodeResult {
  displayName: string;
  latitude: number;
  longitude: number;
}

export async function searchPlace(
  query: string,
  signal?: AbortSignal,
): Promise<GeocodeResult[]> {
  const url =
    "https://nominatim.openstreetmap.org/search?format=json&limit=5&accept-language=" +
    encodeURIComponent(navigator.language || "en") +
    "&q=" +
    encodeURIComponent(query);
  const res = await fetch(url, {
    signal,
    headers: {
      Accept: "application/json",
    },
  });
  if (!res.ok) throw new Error("geocode failed");
  const data: Array<{ display_name: string; lat: string; lon: string }> =
    await res.json();
  return data.map((d) => ({
    displayName: d.display_name,
    latitude: parseFloat(d.lat),
    longitude: parseFloat(d.lon),
  }));
}
